import * as api from '../../api';

import { SelectInput } from '../SelectInput';

interface Props {
  value: string;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
}

export const UsState: React.FC<Props> = ({
  value,
  saveFieldValue,
  updateFieldValue,
}) => {
  return (
    <div>
      <SelectInput
        onChange={(newValue) => {
          updateFieldValue(newValue);
          saveFieldValue(newValue);
        }}
        options={Object.entries(
          api.PrevisitAddress.UsStates.US_STATES_MAPPING,
        ).map(([abbr, display]) => ({
          key: abbr,
          display,
          value: abbr,
        }))}
        value={value}
      />
    </div>
  );
};
